import React from "react";
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok";
import BeforeContent from '../parts/before_content/before_content.js';
import AfterContent from '../parts/after_content/after_content.js';
import Background from '../parts/background/background.js';

const Standard = ({ blok }) => {  
  return (
    <section className={"block_standard content_block" + ((blok.collapse_top_padding) ? ' collapse-top' : '') + ((blok.collapse_bottom_padding) ? ' collapse-bottom' : '')} {...storyblokEditable(blok)} key={blok._uid}>
      <Background blok={blok.background_settings} />
      <div className="inner">
        <BeforeContent blok={blok.before_content} />

        {typeof blok.content_blocks != 'undefined' &&
          <div className="block-content gs_reveal">
            {blok.content_blocks.map((blok) => (
              <StoryblokComponent blok={blok} key={blok._uid} />
            ))}
          </div>
        }

        <AfterContent blok={blok.after_content} />
      </div>
    </section>
  );
}

export default Standard;